(() => {
  if (window._noxteeCheckoutChampProductionHandoffReady) return;
  const productId = '7996565913665';
  const variantMap = Object.freeze({
    '44266883940417': '63.17:1',
    '44266883973185': '83.19:1',
    '44266884005953': '85.21:1'
  });
  const getOffer = (control) => control?.closest('[data-nx-bundle-offer]') || control?.closest('.shopify-section')?.querySelector(`[data-nx-bundle-offer][data-product-id="${productId}"]`);
  const getRoute = (offer) => {
    if (offer?.dataset.productId !== productId) return null;
    const selected = offer.querySelector('[data-nx-bundle-input]:checked');
    const products = variantMap[selected?.value];
    if (!products) return null;
    const url = new URL('https://checkout.noxtee.com/');
    url.searchParams.set('products', products);
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (key !== 'products') url.searchParams.append(key, value);
    });
    return url.toString();
  };
  const resetOfferState = () => {
    document.querySelectorAll('[data-nx-bundle-offer]').forEach((offer) => {
      delete offer.dataset.nxCheckoutchampRedirecting;
      offer.querySelectorAll('[aria-busy="true"]').forEach((control) => control.removeAttribute('aria-busy'));
      offer.querySelectorAll('[data-testid="noxtee-bundle-add-to-cart"], [data-nx-sticky-btn]').forEach((button) => {
        button.disabled = offer.querySelector('[data-nx-bundle-input]:checked')?.dataset.variantAvailable !== 'true';
      });
    });
  };
  const redirect = (offer, control) => {
    const route = getRoute(offer);
    if (!route || offer.dataset.nxCheckoutchampRedirecting === 'true') return;
    offer.dataset.nxCheckoutchampRedirecting = 'true';
    control?.setAttribute('aria-busy', 'true');
    if (control instanceof HTMLButtonElement) control.disabled = true;
    window.location.assign(route);
    window.setTimeout(resetOfferState, 5000);
  };
  const selector = '.nxp__atc, .nxk__btn, [data-nx-sticky-btn], .nx-satc__button';
  const activate = (event) => {
    const control = event.target.closest?.(selector);
    const offer = getOffer(control);
    if (!control || !getRoute(offer)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    redirect(offer, control);
  };
  window.addEventListener('click', activate, true);
  window.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') activate(event);
  }, true);
  window.addEventListener('submit', (event) => {
    const form = event.target.closest?.('form[data-type="add-to-cart-form"]');
    const offer = getOffer(form);
    if (!getRoute(offer)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    redirect(offer, form.querySelector('[data-testid="noxtee-bundle-add-to-cart"]'));
  }, true);
  window.addEventListener('pagehide', resetOfferState);
  window.addEventListener('pageshow', resetOfferState);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') resetOfferState();
  });
  window._noxteeCheckoutChampProductionHandoffReady = true;
})();
